import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "m-mobileControls__container" }
const _hoisted_2 = { class: "m-mobileControls__actionButtons" }
const _hoisted_3 = { class: "m-mobileControls__infoButton" }
const _hoisted_4 = { class: "m-mobileControls__selectionButton" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActionButton = _resolveComponent("ActionButton")!
  const _component_button_component = _resolveComponent("button-component")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_ActionButton, {
            label: {key: _ctx.Translation.Seatmap_action_info},
            "icon-name": _ctx.IconName.Info,
            onClicked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.panelState.activateInfoPanel()))
          }, null, 8, ["label", "icon-name"])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass([{ '-active': _ctx.promotionStore.active }, "m-mobileControls__promoButton"])
        }, [
          (_ctx.promotionStore.availablePromotions.length > 0)
            ? (_openBlock(), _createBlock(_component_ActionButton, {
                key: 0,
                label: {key: _ctx.Translation.Seatmap_action_promo},
                "icon-name": _ctx.IconName.Percentage,
                onClicked: _cache[1] || (_cache[1] = ($event: any) => (_ctx.panelState.activatePromotionPanel()))
              }, null, 8, ["label", "icon-name"]))
            : _createCommentVNode("", true)
        ], 2),
        (_ctx.seatmapStore.priceLevelFilter.length)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass([{'-active': _ctx.isPricelevelSelected}, "m-mobileControls__filterButton"])
            }, [
              _createVNode(_component_ActionButton, {
                "icon-name": _ctx.IconName.SmallFilter,
                label: {key: _ctx.Translation.Seatmap_action_filter},
                onClicked: _cache[2] || (_cache[2] = ($event: any) => (_ctx.panelState.activateFilterPanel()))
              }, null, 8, ["icon-name", "label"])
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_button_component, {
          label: _ctx.actionButtonLabel,
          active: !!_ctx.seatmapStore.getStructuredSelection.length,
          onSubmit: _cache[3] || (_cache[3] = ($event: any) => (_ctx.panelState.activateSelectionPanel()))
        }, null, 8, ["label", "active"])
      ])
    ]),
    _createElementVNode("div", {
      "data-js": "seatmap-back-action",
      style: _normalizeStyle({ display: _ctx.controlState.displayExitLayerButton ? '' : 'none' }),
      class: "m-mobileControls__backButton"
    }, [
      _createVNode(_component_ActionButton, {
        "icon-name": _ctx.IconName.Arrow,
        label: _ctx.exitLevelLabel,
        onClicked: _ctx.layerExit
      }, null, 8, ["icon-name", "label", "onClicked"])
    ], 4)
  ], 64))
}